import React from 'react';
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../../app-constants";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/pagination";

const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Plan",
    description:
      "Using our scrum methodologies, we settle the course of development prioritizing each section of the website as per the project scope.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description:
      "During this phase, we meticulously designed a user-friendly and aesthetically pleasing user interface.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Build",
    description:
      "Our team of web developers then translates the design into a fully functional web app using the latest technology stack.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Test",
    description:
      "Thorough testing is conducted to identify and rectify any bugs, ensuring the seamless functionality of your website.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Launch",
    description:
      "With everything in order, your website is poised to make its debut on web browsers, reaching its intended audience.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Maintenance",
    description:
      "We offer continuous support and updates to keep your app current and responsive to evolving needs.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow lp_flow_slider  p-100 tekrevol_gray_bg">
      <Container className="h-100">
        <Row className="h-100">

          <Col xs={12} md={12} className="my-auto">
            <Row>
              <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                <h2>
                  TekRevol’s Web Development <span>Workflow</span>
                </h2>
              </Col>
              <Col xs={12} md={6} lg={6} xl={7} xxl={7}>
                <p>
                  The procedure for our web app development service is a meticulously planned journey that is organized considering the project scope. By leveraging our agile methodology, we prioritize every phase of the project according to its impact to build a robust product for your business.
                </p>
              </Col>
            </Row>
            <Row className="workflow_secion">
              <Col xs={12} md={12} lg={12} xl={12} xxl={12}>

                <Swiper 
                  loop={true}
                  // navigation={true}
                  spaceBetween={30}
                  pagination={{
                    clickable: true,
                  }}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  modules={[Pagination, Autoplay]}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                    1400: {
                      slidesPerView: 3,
                    },
                    1600: {
                      slidesPerView: 3,
                    },
                  }}
                  className="carousel_lp"
                >   
                  {WorkFlow.map((item, index) => (
                    <SwiperSlide>
                      <div className="workflow_items">
                        <div className="item_name">
                          <span>{item.count}</span>
                          {item.title}
                          <div className="item_icon"> {item.logo}</div>
                        </div>
                        <p>{item.description}</p>
                      </div>

                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default Workflow;
